import { NavItem } from "reactstrap";
import { Href } from "../../Constant";
import { TASK_TAG_DATA } from "../../Data/Task";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { setActiveTab } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { NavClassType } from "../../Type/TaskType";

export const TaskTagData = ({ activeToggle }: NavClassType) => {
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector((state) => state.task);
  const tabHandler = (tab: string) => {
    dispatch(setActiveTab(tab));
    activeToggle(tab);
  };

  return (
    <>
      {TASK_TAG_DATA.map((item) => (
        <NavItem key={item.id}>
          <a href={Href} className={activeTab === item.activeTab ? "show" : ""} onClick={() => tabHandler(item.activeTab)}>
            <span className="title"> {item.title}</span>
          </a>
        </NavItem>
      ))}
    </>
  );
};
